import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function CostComparison() {
  const comparisonRows = [{
    sin: 'Atendés sin argumentos de venta sólidos',
    perdes: 'Clientes que se van sin comprar a la competencia'
  }, {
    sin: 'Sin fichas de degustación',
    perdes: 'Catas improvisadas que no fidelizan'
  }, {
    sin: 'Sin guía de maridajes',
    perdes: 'La venta adicional que nunca se produce'
  }, {
    sin: 'Sin catálogo de varietales',
    perdes: 'Clientes que te preguntan algo y quedás en blanco'
  }, {
    sin: 'Sin sistema de stock',
    perdes: 'Plata inmovilizada en vinos que no rotan'
  }, {
    sin: 'Sin estrategia de redes',
    perdes: 'Vinoteca invisible para clientes nuevos'
  }, {
    sin: 'Sin plan de negocio',
    perdes: 'Crecimiento al azar sin dirección clara'
  }, {
    sin: 'Sin plantillas de contenido',
    perdes: 'Redes sociales abandonadas que no generan nada'
  }];
  return <section className="py-20 bg-[#1a0d2e] text-white" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-21">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="bg-[#0d0716]/60 rounded-2xl p-6 md:p-10 border border-[#3a2456] mb-12 max-w-3xl mx-auto" data-id="element-22">
          <div className="grid grid-cols-2 gap-4 mb-6 pb-4 border-b border-[#3a2456]" data-id="element-23">
            <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-24">
              Sin el Megapack
            </div>
            <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-25">
              Lo que realmente perdés
            </div>
          </div>
          <ul className="space-y-6" data-id="element-26">
            {comparisonRows.map((row, i) => <li key={i} className="grid grid-cols-2 gap-4 items-center" data-id="element-27">
                <div className="flex items-start gap-3" data-id="element-28">
                  <div className="mt-1 bg-[#3a2456] p-1 rounded-full shrink-0 border border-[#5b3a85]" data-id="element-29">
                    <X className="w-4 h-4 text-slate-400" data-id="element-30" />
                  </div>
                  <span className="text-slate-300 text-sm md:text-base" data-id="element-31">
                    {row.sin}
                  </span>
                </div>
                <div className="text-red-300/90 text-sm md:text-base font-medium" data-id="element-32">
                  {row.perdes}
                </div>
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-[#1a0d2e] to-[#3a2456] rounded-2xl p-8 md:p-12 shadow-2xl border border-slate-400/30" data-id="element-33">
          <p className="md:text-3xl font-black text-white text-[20px] mb-6" data-id="element-34">
            🍷🇦🇷 "La próxima vez que entre un cliente a tu vinoteca, podés
            asesorarlo como un experto, sugerirle el maridaje perfecto y cerrar
            la venta con confianza. O podés seguir improvisando."
          </p>
        </motion.div>
      </div>
    </section>;
}